/**
 * Shared state for passing the initial tab type to the CustomExtensionModal.
 * This allows the ExtensionManager's "{}" menu to open the modal with a
 * specific tab pre-selected (file/text/url).
 */
let initialType = 'url';

const setInitialCustomExtensionType = type => {
    initialType = type;
};

const getInitialCustomExtensionType = () => {
    const type = initialType;
    initialType = 'url'; // reset to default after reading
    return type;
};

export {
    setInitialCustomExtensionType,
    getInitialCustomExtensionType
};
